/** Rotas de topo do App.jsx — prefixos para navegação SPA */
export const APP_INTERNAL_ROUTE_PREFIXES = ['/home', '/player', '/user'];

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isAppInternalPathname(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return false;
  }
  return APP_INTERNAL_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/**
 * @param {string} pathname
 * @param {string} search
 * @param {string} hash
 * @returns {string}
 */
function buildInternalTo(pathname, search = '', hash = '') {
  return `${pathname}${search || ''}${hash || ''}`;
}

/**
 * @param {string|null|undefined} href
 * @returns {{
 *   kind: 'none' | 'internal' | 'external',
 *   to?: string,
 *   href?: string,
 * }}
 */
export function resolveCommunicationAdHref(href) {
  const raw = typeof href === 'string' ? href.trim() : '';
  if (!raw) {
    return { kind: 'none' };
  }

  if (raw.startsWith('/')) {
    return { kind: 'internal', to: raw, href: raw };
  }

  if (!/^https?:\/\//i.test(raw)) {
    return { kind: 'external', href: raw };
  }

  try {
    const parsed = new URL(raw);
    const to = buildInternalTo(parsed.pathname, parsed.search, parsed.hash);
    const sameOrigin = typeof window !== 'undefined'
      && parsed.origin === window.location.origin;
    const appPath = isAppInternalPathname(parsed.pathname);

    if (sameOrigin || appPath) {
      return { kind: 'internal', to, href: raw };
    }
    return { kind: 'external', href: raw };
  } catch {
    return { kind: 'external', href: raw };
  }
}
